import { render, staticRenderFns } from "./ZXCare.vue?vue&type=template&id=1a7f2a51"
import script from "./ZXCare.vue?vue&type=script&lang=js"
export * from "./ZXCare.vue?vue&type=script&lang=js"
import style0 from "./ZXCare.vue?vue&type=style&index=0&id=1a7f2a51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports